import { ClerkProvider } from "@clerk/react";
import { passkeys } from "@clerk/electron/passkeys";
import { ClerkProvider as ElectronClerkProvider } from "@clerk/electron/react";
import { DEFAULT_UI_LANGUAGE } from "@t3tools/contracts/settings";
import { useMemo, type ReactNode } from "react";

import { isElectron } from "../../env";
import { useClientSettings } from "~/hooks/useSettings";
import { resolveUiLanguage } from "~/i18n/locale";
import { clerkAppearance } from "./clerkAppearance";
import { resolveClerkLocalization } from "./clerkLocalization";

export function MorrowClerkProvider({
  children,
  publishableKey,
  allowedRedirectProtocols,
}: {
  readonly children: ReactNode;
  readonly publishableKey: string;
  readonly allowedRedirectProtocols?: readonly string[];
}) {
  const preference = useClientSettings((settings) => settings.uiLanguage ?? DEFAULT_UI_LANGUAGE);
  const localization = useMemo(
    () => resolveClerkLocalization(resolveUiLanguage(preference)),
    [preference],
  );

  if (isElectron) {
    return (
      <ElectronClerkProvider
        appearance={clerkAppearance}
        publishableKey={publishableKey}
        passkeys={passkeys}
        localization={localization}
        {...(allowedRedirectProtocols
          ? { allowedRedirectProtocols: [...allowedRedirectProtocols] }
          : {})}
      >
        {children}
      </ElectronClerkProvider>
    );
  }

  return (
    <ClerkProvider
      appearance={clerkAppearance}
      publishableKey={publishableKey}
      localization={localization}
    >
      {children}
    </ClerkProvider>
  );
}
